import { useContext, useState } from "react";
import ContactStyle from "../Contact/Contact.module.css";
import {
  Accordion,
  Button,
  AccordionContext,
  useAccordionButton,
} from "react-bootstrap";
import AddRegisterForm from "./AddRegisterForm";
import AddRegisterFormInd from "./AddRegisterFormInd"; // Assuming you have a separate form for individuals

const Add = ({ visibility, setVisibility, ...props }) => {
  const hrStyle = { margin: ".3rem", border: "none" };

  const [activeKey, setActiveKey] = useState(null);

  // Function to toggle the read more button --------------------------------
  const ContextAwareToggle = ({ children, eventKey, callback, label }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );
    const isCurrentEventKey = activeEventKey === eventKey;

    const handleClick = () => {
      decoratedOnClick(); // This will toggle the accordion section
      setActiveKey(isCurrentEventKey ? null : eventKey);
    };

    return (
      <Button
        style={{
          background: "transparent",
          border: "none",
          color: "white",
          textDecoration: "underline",
        }}
        type="button"
        onClick={handleClick}
      >
        {isCurrentEventKey ? "CLOSE" : label}
      </Button>
    );
  };

  return (
    <>
      {/* Accordion ------------------------------------------- */}
      <section>
        {/* MapButton ------------------------------------------- */}
        <Accordion activeKey={activeKey}>
          <ContextAwareToggle
            setVisibility={setVisibility}
            eventKey="1"
            label="ADD PHARMA"
          />
          <Accordion.Collapse eventKey="1">
            <div>
              <AddRegisterForm />
            </div>
          </Accordion.Collapse>

          <br />

          <ContextAwareToggle
            setVisibility={setVisibility}
            eventKey="2"
            label="ADD INDIVIDUALS"
          />
          <Accordion.Collapse eventKey="2">
            <div>
              <AddRegisterFormInd />
            </div>
          </Accordion.Collapse>
        </Accordion>
        <hr style={hrStyle} />
      </section>
    </>
  );
};

export default Add;
